import { render, staticRenderFns } from "./v_2.vue?vue&type=template&id=0b581bf8"
import script from "./v_2.vue?vue&type=script&lang=js"
export * from "./v_2.vue?vue&type=script&lang=js"
import style0 from "./v_2.vue?vue&type=style&index=0&id=0b581bf8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports